<template>
    <div>
        <b-table
                id="cdasExcluida"
                :items="resultado"
                :fields="fields"
                striped
                small
                :no-local-sorting="true"
                @sort-changed="sortingChanged"
                :busy="configTable.load"
                show-empty
        >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>

            <template slot="empty">
                <p class="my-auto">Nenhum registro encontrado.</p>
            </template>

            <template slot="1" slot-scope="row" >
                <b-link @click="abrirModalExtratoCda(codCdaSefa[0])" v-for="codCdaSefa in row.item.codCdaSefa" :key="codCdaSefa"
                        :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    <p class="m-0 p-0"> {{ codCdaSefa[1] }} </p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj"
                   :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ devedor.nome }}
                </p>
            </template>
            <template slot="3" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj"
                   :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ devedor.cpfCnpj | cpfCnpj }}
                </p>
            </template>
            <template slot="4" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ row.item.comarca }}
                </p>
            </template>
            <template slot="5" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    {{ row.item.tipoCredito }}
                </p>
            </template>
            <template slot="6" slot-scope="row">
                <p v-for="devedor in row.item.devedores" :key="devedor.cpfCnpj" v-if="devedor.cadicms != null"
                   :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ devedor.cadicms }}
                </p>
            </template>
            <template slot="7" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ row.item.assunto }}
                </p>
            </template>
            <template slot="8" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    {{ row.item.dataInscricaoFormatada }}
                </p>
            </template>
            <template slot="9" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    {{ row.item.dataAjuizamentoFormatada != "" ?  row.item.dataAjuizamentoFormatada : "Aguardando TJ" }}
                </p>
            </template>
            <template slot="10" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    {{ row.item.dataDistribuicaoFormatada }}
                </p>
            </template>
            <template slot="11" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-center font-red' : 'text-center'">
                    {{ row.item.numeroUnico | numeroUnico }}
                </p>
            </template>
            <template slot="12" slot-scope="row">
                <p :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ row.item.juizo }}
                </p>
            </template>
            <template slot="13" slot-scope="row">
                <p class="m-0 p-0" v-for="dataPagamento in row.item.datasPagamento"
                   :class="row.item.naoDistribuido ? 'text-left font-red' : 'text-left'">
                    {{ dataPagamento }}
                </p>
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
    import ExtratoCda from "../../shared/components/ExtratoCda";
    export default {
        components: {ExtratoCda},
        props: ['resultado', 'fields', 'configTable'],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false
                this.$emit('consultarDividas')
            }
        },
        computed: {
            currentPage() {
                return this.configTable.currentPage
            }
        },
        methods: {
            sortingChanged(ctx) {
                if(ctx.sortBy == 1) {
                    this.configTable.sortField = 'numeroDivida';
                }
                if(ctx.sortBy == 2) {
                    this.configTable.sortField = 'contribuinte';
                }
                if(ctx.sortBy == 3) {
                    this.configTable.sortField = 'cpfCnpj';
                }
                if(ctx.sortBy == 4) {
                    this.configTable.sortField = 'comarca';
                }
                if(ctx.sortBy == 5) {
                    this.configTable.sortField = 'tipoCredito';
                }
                if(ctx.sortBy == 6) {
                    this.configTable.sortField = 'cadicms';
                }
                if(ctx.sortBy == 7) {
                    this.configTable.sortField = 'assunto';
                }
                if(ctx.sortBy == 8) {
                    this.configTable.sortField = 'dataInscricao';
                }
                if(ctx.sortBy == 9) {
                    this.configTable.sortField = 'dataAjuizamento';
                }
                if(ctx.sortBy == 10) {
                    this.configTable.sortField = 'dataDistribuicao';
                }
                if(ctx.sortBy == 11) {
                    this.configTable.sortField = 'numeroUnico';
                }
                if(ctx.sortBy == 12) {
                    this.configTable.sortField = 'juizo';
                }
                if(ctx.sortBy == 13) {
                    this.configTable.sortField = 'dataPagamentoParcelamento';
                }
                this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
                this.$emit('sortingChanged');
            },
            abrirModalExtratoCda(codCdaSefa) {
                this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
            },
            closeModal() {
                this.$refs['extratoCda'].fecharModais();
            },
        }
    }
</script>

<style>

</style>
